module.exports = "//__CDN_HOST__/2.0.8/img/More-1.a6f25417.png";